import { asContainer } from 'lib/container'

import { Error } from 'components/Error'

export const container = asContainer<{}>()({
	authentication: { type: 'public' },
	Running: () => <Error />,
})
